import { InjectionToken } from '@angular/core'
import { AuthConfiguration } from './auth-configuration'

export const STANDALONE_APP_CONFIGURATION = new InjectionToken<AuthConfiguration>('STANDALONE_APP_CONFIGURATION')

export interface StandaloneAppConfiguration {
  appDownloadUrl: string
}
